const licenseKey = 'CompanyName=NorgesGruppen Data AS,LicensedGroup=LPX-PRMS-TAS Ami Thomasgaard,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=6,LicensedProductionInstancesCount=0,AssetReference=AG-022717,ExpiryDate=22_January_2023_[v2]_MTY3NDM0NTYwMDAwMA==14e0e4b255cf186887dc57b3aeaeda8b';

export default licenseKey;
